import { REQUEST_URL } from "../constants";
import { RequestUtil, RequestFileUtil } from "../utils";
import { FocusedMarketInputModel } from "../models";

export const FocusedMarketService = {
  getAllFocusedMarketPageByLanguage,
  getFocusedMarketPage,
  createFocusedMarketPage,
  uploadImageFocusedMarketPage,
  deleteFocusedMarketPage,
  updateFocusedMarketPage
};

async function getAllFocusedMarketPageByLanguage(query: { languageId: string }) {
  const url = REQUEST_URL.GET_ALL_FOCUSED_MARKET_PAGE_BY_LANGUAGE;

  return RequestUtil.get({ url, query });
}

async function getFocusedMarketPage(code: string, query?: { languageId?: string }) {
  const url = REQUEST_URL.GET_FOCUSED_MARKET_PAGE.replace("{CODE}", code);;

  return RequestUtil.get({ url, query });
}

async function createFocusedMarketPage(data: FocusedMarketInputModel[]) {
  const url = REQUEST_URL.CREATE_FOCUSED_MARKET_PAGE;

  return RequestUtil.post({ url, data });
}

async function uploadImageFocusedMarketPage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_FOCUSED_MARKET;

  return RequestFileUtil.post({ url, data: formData });
}

async function updateFocusedMarketPage(code: string, data: FocusedMarketInputModel[]) {
  const url = REQUEST_URL.UPDATE_FOCUSED_MARKET_PAGE.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

async function deleteFocusedMarketPage(code: string) {
  const url = REQUEST_URL.DELETE_FOCUSED_MARKET_PAGE.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}